import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from './loading.service';
import { ToastService } from './toast.service';
import { environment as env } from '../../environments/environment';

// Read-only client for /rest/tickers-master. Powers the "Tickers Master"
// pane under /admin/common-data. The row shape is intentionally left
// open (`any`) so the component can derive columns from whatever fields
// the current collection carries — no hardcoded schema here.

export type TickersMasterRow = Record<string, any>;

@Injectable({ providedIn: 'root' })
export class TickersMasterService {
  constructor(
    private http: HttpClient,
    private loadingService: LoadingService,
    private toast: ToastService,
  ) {}

  private _opts() { return { withCredentials: true }; }
  private _base() { return `${env.apiUrl}/rest/tickers-master`; }

  async listAll(): Promise<TickersMasterRow[]> {
    const id = this.loadingService.add('Loading tickers_master');
    const url = this._base();
    try {
      const res: any = await this.http.get(url, this._opts()).toPromise();
      return Array.isArray(res?.rows) ? res.rows as TickersMasterRow[] : [];
    } catch (e: any) {
      this._toastErr('Tickers master', e, 'F2A_TICKERS_MASTER_LIST_FAIL', url);
      return [];
    } finally {
      this.loadingService.remove(id);
    }
  }

  private _toastErr(title: string, e: any, code: string, requestUrl?: string) {
    const msg = e?.error?.errors?.[0]?.message || e?.message || 'Unknown error';
    this.toast.error(title, msg, {
      error_code: code,
      customer: 'f2-admin',
      scanner_path: '/admin/common-data',
      request_url: requestUrl || e?.url || undefined,
      http_status: e?.status ?? 0,
      content_type: (e?.headers?.get?.('content-type') as string | undefined) || (e?.error && typeof e.error === 'string' ? 'text/html' : 'application/json'),
      f2_response_body: (typeof e?.error === 'string' ? e.error : JSON.stringify(e?.error || {})).slice(0, 500),
      f2_response_message: msg,
    });
  }
}
